import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/what-is-mulebuy-spreadsheet/page";
import SEOArticlePage from "../pages/seo-article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-mulebuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/:articleId",
    element: <SEOArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;